import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { DougPostCardStackBackgroundViewModel } from './doug-post-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-doug-post-card-stack-background',
  templateUrl: './doug-post-card-stack-background.component.html',
  styleUrls: ['./doug-post-card-stack-background.component.scss'],
  providers: [DougPostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DougPostCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: DougPostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
